import FuseLoading from '@fuse/core/FuseLoading';
import { DialogContent, Divider } from '@mui/material';
import AppSimpleDialog from 'app/shared-components/dialogs/AppSimpleDialog';
import { ModalComponent } from 'app/shared-components/modals/modalManager';

export const NorthApplicationLoadingModal: ModalComponent = ({ open, onClose }) => {
  return (
    <AppSimpleDialog open={open} handleClose={onClose} title="Please wait..." hideCloseButton>
      <Divider />
      <DialogContent className="flex flex-col items-center justify-center min-h-[200px]">
        <FuseLoading />
        <div className="mt-16 text-center">Preparing your application form...</div>
      </DialogContent>
    </AppSimpleDialog>
  );
};
